import { c as _c } from "react/compiler-runtime";
import React from "react";
import { Donation } from "../../../../store/state";
import payment from "../PaymentPane.module.scss";
export const PaymentInformation: React.FC<{
  accountTitle: string;
  kidTitle: string;
  donation: Donation;
  accountNr: string;
}> = t0 => {
  const $ = _c(17);
  const {
    donation,
    accountTitle,
    kidTitle,
    accountNr
  } = t0;
  let t1;
  if ($[0] !== accountTitle) {
    t1 = <span>{accountTitle}</span>;
    $[0] = accountTitle;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== accountNr) {
    t2 = <span>{accountNr}</span>;
    $[2] = accountNr;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={payment.roundedBorder}><div className={payment.textWrapper}>{t1}{t2}</div></div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== kidTitle) {
    t4 = <span>{kidTitle}</span>;
    $[7] = kidTitle;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== donation.kid) {
    t5 = <span data-cy="kidNumber">{donation.kid}</span>;
    $[9] = donation.kid;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className={payment.roundedBorder}><div className={payment.textWrapper}>{t4}{t5}</div></div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t6) {
    t7 = <>{t3}{t6}</>;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};